import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class SalaryTypePage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { salaryTypePage,currentSalaryType} = this.props.system;
     this.fetchList( salaryTypePage);
  }

  fetchList = (page,values) => {
    const {getSalaryTypeList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getSalaryTypeList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { salaryTypeById, salaryTypeList } = system;
    if (!salaryTypeList) return [];
    return salaryTypeList.map(id => salaryTypeById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getSalaryTypeListPending,salaryTypeTotal,salaryTypePage } = system
    const { deleteSalaryType,chooseCurrentSalaryType,salaryTypeModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getSalaryTypeListPending,
      columns:[
        {
          title: "类型名",
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:salaryTypeTotal,
        current:salaryTypePage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentSalaryType(record);
          salaryTypeModalChange(true,"updata");
        }else if(item.key == 3){
            deleteSalaryType(record.id).then((data) => {
            this.fetchList(salaryTypePage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentSalaryType, salaryTypeModalVisible,salaryTypePage, salaryTypeModalType,submitSalaryTypePending } = system

    const { salaryTypeModalChange,submitSalaryType } = actions;
    const editItem  = salaryTypeModalType === 'create' ? {} : currentSalaryType
    return {
      item: salaryTypeModalType === 'create' ? {} : currentSalaryType,
      visible: salaryTypeModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitSalaryTypePending,
      title: `${
        salaryTypeModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "name",
          label: "类型",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitSalaryType(Object.assign({},data,{})).then(data=> {
          salaryTypeModalChange(false,"create");
          this.fetchList(salaryTypePage);
        })
      },
      onCancel() {
        salaryTypeModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentSalaryType,salaryTypePage} = system
    const { salaryTypeModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "name",
            widget: Input,
            widgetProps:{
                placeholder:"请输入类型名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        salaryTypeModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentSalaryType,salaryTypePage} = system
    const { salaryTypeModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ salaryTypeModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalaryTypePage);


// WEBPACK FOOTER //
// ./src/features/system/SalaryTypePage.js